import React from 'react';

const Reconciliation = () => (
	<a href="https://facebook.github.io/react/docs/reconciliation.html" target="_blank" rel="noopener noreferrer">More for read</a>
	)

export default Reconciliation;


// WEBPACK FOOTER //
// ./src/pages/advance/reconciliation/index.jsx